<template>
    <div class="homeBox">
        <div class="homeMainBox">
            <div class="homeMain">
                <div class="homeMain_left">
                    <div>
                        <div style="margin-top: 10px" v-for="operrecord in sysOperationLogList" :key="operrecord.solId">
                            <p class="changedate">{{ operrecord.createTime }}</p>
                            <div style="margin-top: 10px; display: flex">
                                <div>
                                    <i
                                        :class="[
                                            operrecord.operationType.code == 'upd'
                                                ? 'el-icon-edit-outline'
                                                : operrecord.operationType.code == 'del'
                                                ? 'el-icon-delete-solid'
                                                : operrecord.operationType.code == 'ins'
                                                ? 'el-icon-circle-plus'
                                                : 'el-icon-receiving'
                                        ]"
                                    ></i>
                                </div>
                                <div style="margin-top: -3px">
                                    <span style="margin-left: 5px"><!--{{ operrecord.fcName }}-->{{ operrecord.userName }}{{ operrecord.operationModel.desc }}{{ operrecord.operationType.desc }}</span>
                                </div>
                                <!-- <div class="changetime">
                                <span>两个月前</span>
                            </div> -->
                            </div>
                        </div>
                    </div>
                    <div style="margin-right: 10px; margin-top: 10px;position:absolute;right:10px;" v-if="sysOperationLogList != undefined">
                        <el-button type="primary" size="mini" @click="getAllLogs" v-if="$t('lang')=='zh'">查看全部</el-button>
                    </div>
                </div>
                <div class="homeMain_right">
                    <div class="homeMain_right_item" @click="jump('organization')">
                        <img src="../../assets/imgs/itemImg.png" />
                        <p>{{$t('demo.menu.MasterData')}}</p>
                    </div>
                    <div class="homeMain_right_item" @click="jump('deviceList')" v-if="$t('lang')=='zh'">
                        <img src="../../assets/imgs/itemImg.png" />
                        <p>设备管理</p>
                    </div>
                    <div class="homeMain_right_item" @click="jump('toolingInfo')" v-if="$t('lang')=='zh'">
                        <img src="../../assets/imgs/itemImg.png" />
                        <p>工装管理</p>
                    </div>
                    <div class="homeMain_right_item" @click="jump('sparePartInfo')">
                        <img src="../../assets/imgs/itemImg.png" />
                        <p>{{$t('demo.menu.SpareParts')}}</p>
                    </div>
                    <div class="homeMain_right_item" @click="jump('andonOrderList')" v-if="$t('lang')=='zh'">
                        <img src="../../assets/imgs/itemImg.png" />
                        <p>安灯管理</p>
                    </div>
                    <div class="homeMain_right_item" @click="jump('deviceReport')" v-if="$t('lang')=='zh'">
                        <img src="../../assets/imgs/itemImg.png" />
                        <p>报表分析</p>
                    </div>
                    <div class="homeMain_right_item" @click="jump('facilitySpectaculars')" v-if="$t('lang')=='zh'">
                        <img src="../../assets/imgs/itemImg.png" />
                        <p>可视化看板</p>
                    </div>
                    <div class="homeMain_right_item" @click="jump('eigDQuestion')" v-if="$t('lang')=='zh'">
                        <img src="../../assets/imgs/itemImg.png" />
                        <p>8D流程管理</p>
                    </div>
                    <div class="homeMain_right_item" @click="jump('suggest')" v-if="$t('lang')=='zh'">
                        <img src="../../assets/imgs/itemImg.png" />
                        <p>建议管理</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Home',
        data () {
            return {
                sysOperationLogList: [],
                userInfo: {}
            }
        },
        destroyed () {
            // 在页面销毁后，清除计时器
            this.clear()
        },
        created () {
            // this.dataRefreh()
        },
        mounted () {
            this.init()
        },
        methods: {
            init () {
                this.userInfo = this.$store.state.userInfo
                this.getSysOperationLogList()
            },
            // 定时刷新数据函数
            dataRefreh () {
                // 计时器正在进行中，退出函数
                if (this.intervalId != null) {
                    return
                }
                // 计时器为空，操作
                this.intervalId = setInterval(() => {
                    console.log('刷新' + new Date())
                    this.getSysOperationLogList() //加载数据函数
                }, 5000)
            },
            // 停止定时器
            clear () {
                clearInterval(this.intervalId) //清除计时器
                this.intervalId = null //设置为null
            },
            getSysOperationLogList () {
                let params = {}
                let userInfo = JSON.parse(sessionStorage.getItem("userInfo"))
                let str = ''
                if (this.userInfo.factoryId != 0) {
                    for (let i = 0; i < userInfo.roles.length; i++) {
                        str += userInfo.roles[i].fcCode + ','
                    }
                    str = str.substring(0, str.length - 1)
                    params['fcCode'] = str
                }
                let options = {
                    method: 'get',
                    url: this.$api.sysOperationLogList,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.sysOperationLogList = response.data.list
                        // this.diaplayTime()
                    }
                })
            },
            getAllLogs(){
                this.$router.push({
                    name: 'allLog'
                })
            },
            diaplayTime: function (dateTimeStamp) {
                let newT = dateTimeStamp.replace(/-/g, '/') //ios时间格式转换时，要求2019/07/04
                var result
                var minute = 1000 * 60
                var hour = minute * 60
                var day = hour * 24
                var halfamonth = day * 15
                var month = day * 30
                var now = new Date().getTime()
                var curTime = new Date(newT) //后端返回的是秒数
                var diffValue = now - curTime
                //console.log('dateTimeStamp',dateTimeStamp);
                //console.log('diffValue',diffValue);
                if (diffValue < 0) {
                    return
                }
                var monthC = diffValue / month
                var weekC = diffValue / (7 * day)
                var dayC = diffValue / day
                var hourC = diffValue / hour
                var minC = diffValue / minute
                if (monthC >= 1) {
                    if (monthC <= 12)
                        result = "" + parseInt(monthC) + "月前"
                    else {
                        result = "" + parseInt(monthC / 12) + "年前"
                    }
                } else if (weekC >= 1) {
                    result = "" + parseInt(weekC) + "周前"
                } else if (dayC >= 1) {
                    result = "" + parseInt(dayC) + "天前"
                } else if (hourC >= 1) {
                    result = "" + parseInt(hourC) + "小时前"
                } else if (minC >= 1) {
                    result = "" + parseInt(minC) + "分钟前"
                } else {
                    result = "刚刚"
                }
                this.setData({
                    diaplayTime: result
                })
                return result
            },
        }
    }
</script>

<style scoped lang="scss">
    // 滚动条样式
    ::-webkit-scrollbar {
        width: 4px !important;
        /*height: 4px;*/
    }

    ::-webkit-scrollbar-thumb {
        border-radius: 10px !important;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.068) !important;
        background: rgba(0, 0, 0, 0.068) !important;
    }

    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.068) !important;
        border-radius: 0 !important;
        background: rgba(0, 0, 0, 0.068) !important;
    }
    .homeBox {
        background-image: url('../../assets/imgs/indexbg.png');
        background-size: 100% 100%;
        overflow: hidden;
        height: 39vw;
    }
    .homeMainBox {
        width: 115vh;
        height: 60vh;
        margin: 0 auto;
        margin-top: 9vh;
        border-radius: 10px;
        overflow: hidden;
        background-color: #cee6ff;
        .homeMain {
            width: 100%;
            height: 55vh;
            padding: 3vh;
            margin-top: 5vh;
            border: 1px solid #ccc;
            border-top: 2vh solid rgb(117, 177, 239);
            background-color: white;
            .homeMain_left {
                float: left;
                width: 55%;
                height: 100%;
                display: flex;
                overflow: auto;
                position: relative;
                text-align: left;
                margin-top: -1vw;
                // background-image: url('../../assets/imgs/imgBoxImg.png');
                // background-size: 85% 100%;
                // background-position: center;
                // background-repeat: no-repeat;
                border-right: 1px dashed #ccc;
                .changedate {
                    font-size: 17px;
                    font-weight: bold;
                }
                div {
                    .changetime {
                        color: #ccc;
                        margin-top: -3px;
                        margin-left: 13px;
                        margin-right: 15px;
                        white-space: nowrap;
                    }
                }
                .textcol {
                    color: #205a81;
                    padding-left: 3px;
                    padding-right: 3px;
                }
            }
            .homeMain_right {
                float: left;
                width: 45%;
                margin-top: -2vw;
                height: 100%;
                padding: 3vh;
                .homeMain_right_item {
                    cursor: pointer;
                    padding: 2vh;
                    width: calc(47% - 8vh);
                    height: calc(40% - 4vh);
                    margin: 2vh 1vh;
                    float: left;
                    border-radius: 10px;
                    transition: all 0.2s;
                    box-shadow: 0px 5px 15px rgba(117, 177, 239, 0.5);
                    img {
                        width: 50%;
                        height: auto;
                    }
                    p {
                        color: #000;
                        margin-top: 0.5vh;
                    }
                }
                .homeMain_right_item:hover {
                    box-shadow: 0px 5px 25px rgba(117, 177, 239, 1);
                }
            }
        }
    }
</style>
